import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const fmt12 = (h, m) => `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;

export const TIME_OPTIONS = [];
for (let h = 0; h < 24; h++) {
  for (const m of [0, 30]) {
    TIME_OPTIONS.push({ value: `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`, label: fmt12(h, m) });
  }
}

export const TimeSelect = ({ value, onChange, testId, placeholder = "Pick a time" }) => (
  <Select value={value || ""} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="mt-1.5">
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="max-h-64">
      {TIME_OPTIONS.map((t) => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}
    </SelectContent>
  </Select>
);

const t2m = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };

export function estimateHours(startDate, endDate, startTime, endTime) {
  if (!startDate || !endDate || !startTime || !endTime) return null;
  const s = new Date(`${startDate}T00:00:00`);
  const e = new Date(`${endDate}T00:00:00`);
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime()) || e < s) return null;
  let total = 0;
  for (let d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
    if (d.getDay() === 0 || d.getDay() === 6) continue;
    const begin = d.getTime() === s.getTime() ? t2m(startTime) : 540;
    const end = d.getTime() === e.getTime() ? t2m(endTime) : 1020;
    total += Math.max(0, Math.min((end - begin) / 60, 8));
  }
  return Math.round(total * 100) / 100;
}
